import { ActionType } from 'flow/store/engine/constants';
import { SNIPPET_SCOPE } from './types';
import type { SnippetScope } from './types';

export const LOCAL_STORAGE_SNIPPET_KEY = 'snippetVersion' as const;

export const SCOPE_DESCRIPTIONS: Partial<Record<SnippetScope, string>> = {
  [SNIPPET_SCOPE.GLOBAL]: '"Global" Snippets are visible to all Alloy customers.',
  [SNIPPET_SCOPE.INTERNAL]: '"Internal" Snippets are visible to Alloy Admin users only.',
};

export const incompatibleGlobalSnippetActionTypes = [
  ActionType.SNIPPET,
  ActionType.OUTCOME_REASON,
  ActionType.IMPORTED_MATRIX_MODEL,
  ActionType.IMPORTED_OUTPUT_ATTRIBUTE,
  ActionType.OUTCOME,
];

export const incompatibleLocalSnippetActionTypes = [
  ActionType.SNIPPET,
  ActionType.OUTCOME,
];

export const externalSnippetActionTypes = [
  ActionType.INPUT,
  ActionType.OUTCOME_REASON,
  ActionType.IMPORTED_OUTPUT_ATTRIBUTE,
  ActionType.IMPORTED_MATRIX_MODEL,
];
